<template>
  <div class="sellGold">
    <Header />
    <div>
      <div class="home-page" v-if="!isConfirmed">
        <div class="container">
          <div class="middle-panel">
            <div class="gold-item">
              <GoldDetails :goldPrice="currentGoldAmount" />
            </div>
            <div class="gold-item gold-content">
              <UserGoldDetail />
            </div>
          </div>
        </div>
        <div class="checkbox">
          <div class="Amount-box">
            <label class="radio-group">
              <input
                type="radio"
                checked
                v-model="amountType"
                value="gram"
                @change="amountTypehandler"
              />
              {{ $t("sellingrams") }}
              <span class="circle"></span>
            </label>
            <label class="radio-group">
              <input
                type="radio"
                checked
                v-model="amountType"
                value="amount"
                @change="amountTypehandler"
              />
              {{ $t("sellinamount") }}
              <span class="circle"></span>
            </label>
          </div>
          <div class="amount-text">
            <input
              type="number"
              :placeholder="symbol"
              v-model="amount"
              @input="getGoldConversionResult"
            />
            <span> {{ goldConversionResult }} {{ unit }} </span>
          </div>
          <Button @goBack="confrimGoldData" :btn_txt="$t('sellgold')" />
        </div>
        <div class="scroll-content">
          <QA></QA>
        </div>
      </div>
      <div class="loader" v-if="loading">
        <img
          src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif"
        />
      </div>
      <!-- confirmed pop-->
      <div class="container amountTransfer" v-if="isConfirmed">
        <Timer :timing="240" :text="$t('time')" />
        <div class="mid-panel amount-description">
          <span class="transfer-handing">{{ $t("transferdescription") }}</span>
          <div class="Amount-box">
            <label class="radio-group">
              <input
                type="radio"
                checked
                v-model="transitionSection"
                value="paytm"
              />
              Paytm
              <span class="circle"></span>
            </label>
            <label class="radio-group" v-if="roundOff(sell_price, 2) >= 50">
              <input
                type="radio"
                checked
                v-model="transitionSection"
                value="bank"
              />
              {{ $t("bank") }}
              <span class="circle"></span>
            </label>
          </div>
          <div
            v-if="user.user_bank_account_details.hasOwnProperty('bank')"
            class="bank-description"
          >
            {{ $t("bankaccount") }} :
            {{ user.user_bank_account_details.bank[0].account_number }}
          </div>

          <div class="bank_transition" v-if="transitionSection === 'bank'">
            <div
              v-if="user.user_bank_account_details.hasOwnProperty('upi')"
              class="bank-description"
            >
              UPI : {{ user.user_bank_account_details.upi[0].upi_id }}
            </div>
            <div class="amount-details transferdetail">
              <div class="offer-price">
                <div class="details">
                  {{ $t("total_amount") }}:
                  <div class="price">₹{{ roundOff(sell_price, 2) }}</div>
                </div>
              </div>
              <div class="offer-price">
                <div class="details">
                  {{ $t("refundinbank") }}:
                  <div class="price">
                    ₹{{ roundOff(sell_price - wallet, 2) }}
                  </div>
                </div>
              </div>
              <div class="offer-price">
                <div class="details">
                  {{ $t("refundinwallet") }}:
                  <div class="price">₹{{ wallet }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="paytm_transition" v-if="transitionSection === 'paytm'">
            <div class="paytm_details_note">
              <div class="note" v-if="roundOff(sell_price, 2) < 50">
                <p>
                  <b>{{ $t("note") }}: </b>{{ $t("sinceamountlessthan") }},
                  {{ $t("amountshow") }} {{ transitionNumber }}
                  {{ $t("transferredpaytmwallet") }}
                </p>
              </div>
              <div class="feild">
                <span>
                  <img src="../assets/images/paytm_logo-icon.png" alt="" />
                </span>
                <input
                  class="ak"
                  type="text"
                  placeholder="1234567890"
                  v-model="transitionNumber"
                />
              </div>
            </div>
            <div class="amount-details transferdetail">
              <div class="offer-price">
                <div class="details">
                  {{ $t("total_amount") }}:
                  <div class="price">₹{{ roundOff(sell_price, 2) }}</div>
                </div>
              </div>
              <div class="offer-price">
                <div class="details">
                  {{ $t("refundpaytm") }}:
                  <div class="price">
                    ₹{{ roundOff(sell_price - wallet, 2) }}
                  </div>
                </div>
              </div>
              <div class="offer-price">
                <div class="details">
                  {{ $t("refundinwallet") }}:
                  <div class="price">₹{{ wallet }}</div>
                </div>
              </div>
            </div>
          </div>
          <Button class="mr" @goBack="sellGold" :btn_txt="$t('confirm')" />
          <Button
            class="mr mr_cancel"
            @goBack="cancelRequest"
            :btn_txt="$t('cancel')"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "../components/Header";
import GoldDetails from "../components/GoldDetails";
import UserGoldDetail from "../components/UserGoldDetail";
import Button from "../components/Button";
import QA from "../components/QA";
import Timer from "../components/Timer";
import { isNumber } from "../utils/validators";
import { SessionHelper } from "../utils/session";
import {
  toaster,
  getPriceByWeight,
  getWeightByPrice,
  roundDown,
  isAmountUpto2decimal,
  isGoldUpto4decimal,
  roundOff
} from "../utils/helper";
export default {
  name: "SellGold",
  components: {
    Header,
    GoldDetails,
    Button,
    UserGoldDetail,
    QA,
    Timer
  },
  data() {
    return {
      amountType: "gram",
      goldConversionResult: 0,
      transitionSection: "paytm",
      unit: "Rs",
      loading: false,
      symbol: "1 gram",
      amount: "",
      isConfirmed: false,
      transitionNumber: "",
      currentGoldAmount: 0
    };
  },

  computed: {
    ...mapGetters(["user", "gold"])
  },

  methods: {
    roundOff,
    roundDown,
    cancelRequest() {
      this.isConfirmed = !this.isConfirmed;
      this.amount = "";
      this.goldConversionResult = 0;
    },

    amountTypehandler(e) {
      const { amountType } = this;
      this.amount = "";
      this.goldConversionResult = 0;
      if (amountType === "gram") {
        this.unit = "Rs";
        this.symbol = "1 gram";
      } else {
        this.unit = "gram";
        this.symbol = "₹ xxxx";
      }
    },

    getGoldConversionResult(event) {
      const { value } = event.target;
      const { amountType } = this;
      const { selling_record } = this.userGoldData;
      if (amountType === "amount") {
        if (!isNumber(value)) {
          this.amount = "";
          return;
        }
        this.goldConversionResult = roundDown(
          getWeightByPrice(selling_record.current_price, value),
          4
        );
      } else {
        this.goldConversionResult = roundOff(
          getPriceByWeight(selling_record.current_price, value),
          2
        );
      }
    },

    getWallet(sell_price) {
      const { sold_offer } = this.user;
      const wallet_amount =
        (Number(sell_price) * sold_offer.wallet_percentage) / 100;
      if (roundOff(wallet_amount, 2) > sold_offer.max_wallet) {
        return sold_offer.max_wallet;
      }
      return roundOff(wallet_amount, 2);
    },

    confrimGoldData() {
      const { total_gold_amount, selling_record } = this.userGoldData;
      const { amountType, amount } = this;
      let payload = { gold_sold_in_rupees: Number(amount) };
      if (amountType === "gram") {
        const rupee = amount * this.gold.current_price;
        if (rupee < 1) {
          this.amount = ""
          toaster(this, this.$t("amountlessthanrs2"), "top-left", 3000);
          return;
        }
        if (amount <= 0 || !isGoldUpto4decimal(amount)) {
          this.amount = ""
          toaster(this, this.$t("amountcannotzero"), "top-left", 3000);
          return;
        }
        if (Number(amount) > Number(total_gold_amount)) {
          this.amount = ""
          toaster(this, this.$t("enoughgoldtosell"), "top-left", 3000);
          return;
        }
        payload = { gold_sold_in_grams: Number(amount) };
      } else {
        if (amount < 10 || !isAmountUpto2decimal(amount)) {
          this.amount = ""
          toaster(this, "Amount should be equal and more than 10 Rs", "top-left", 3000);
          return;
        }
        const current_gold_amount = amount / selling_record.current_price;
        if (roundDown(current_gold_amount, 4) > total_gold_amount) {
          this.amount = ""
          toaster(this, this.$t("enoughgoldtosell"), "top-left", 3000);
          return;
        }
      }
      this.loading = !this.loading;
      this.$store
        .dispatch({ type: "sellVerifaction", payload })
        .then(data => {
          this.loading = !this.loading;
          if (data.data.success) {
            this.wallet = this.getWallet(data.data.data.sell_price);
            this.tx_id = data.data.data.tx_id;
            this.isConfirmed = !this.isConfirmed;
            this.sell_price = data.data.data.sell_price;
          } else {
            this.amount = "";
            this.goldConversionResult = 0;
            toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
          }
        })
        .catch(err => {
          this.loading = !this.loading;
          this.amount = "";
          this.goldConversionResult = 0;
          toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
        });
    },

    sellGold() {
      SessionHelper.refereshJwtToken();
      this.loading = !this.loading;
      let obj;
      let pytm_number;
      if (this.transitionSection === "paytm") {
        obj = {
          tx_id: this.tx_id,
          paytm_number: this.transitionNumber
        };
      } else {
        obj = {
          tx_id: this.tx_id
        };
      }
      this.$store
        .dispatch({
          type: "sellConfirmation",
          payload: obj
        })
        .then(data => {
          this.loading = !this.loading;
          if (data.data.success) {
            toaster(this, this.$t("successfullysoldgold"), "top-left", 9000);
            this.$router.push("/");
          }
        })
        .catch(err => {
          this.loading = !this.loading;
          toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
          this.$router.push("/");
        });
    }
  },

  mounted() {
    this.loading = !this.loading;
    this.$store
      .dispatch({ type: "getGoldAmount" })
      .then(data => {
        this.loading = !this.loading;
        this.userGoldData = data.data.data;
        this.currentGoldAmount = this.userGoldData.selling_record.current_price;
        this.transitionNumber = this.userGoldData.phone_number;
      })
      .catch(err => {
        this.loading = !this.loading;
        toaster(this, this.$t("somethingwentwrong"), "top-left", 3000);
        this.$router.push("/");
      });
  }
};
</script>
